export default function translateServerErrorIntoFriendlyMessage(error: Error) {
  if (/Comment not found/i.test(error.message)) {
    return "Comentário não encontrado";
  }

  if (/Comment is already locked/i.test(error.message)) {
    return "Este comentário já está trancado";
  }

  if (/Comment is already unlocked/i.test(error.message)) {
    return "Este comentário já está destrancado";
  }

  if (/Only Premium users are allowed to comment/i.test(error.message)) {
    return "Apenas usuários Premium podem enviar comentários.";
  }

  if (
    /You're not allowed to post a comment with less than 3 characters/i.test(error.message) ||
    /Comment is too short/i.test(error.message)
  ) {
    return "Seu comentário deve ter no mínimo 3 caracteres.";
  }

  if (
    /You're not allowed to post a comment with more than ([\d+]) characters/i.test(error.message) ||
    /Comment is too long/i.test(error.message)
  ) {
    return "Seu comentário é muito grande. Por favor, tente novamente com um comentário menor.";
  }

  if (/Couldn't post the comment/i.test(error.message)) {
    return "Não foi possível publicar seu comentário.";
  }

  if (/You're not authorized/i.test(error.message)) {
    return "Não foi possível publicar seu comentário por que sua sessão expirou. Por favor, faça o login novamente.";
  }

  return "Whoopz...deu algum problema aqui no servidor. Tente novamente mais tarde :(";
}
